export const accessoryoptions = [
	  { value: 'Bottle', label: 'Bottle', parm: 'accessories' },
	  { value: 'Music', label: 'Music', parm: 'accessories' },
	  { value: 'Pipe', label: 'Pipe', parm: 'accessories' },
	  { value: 'Potion', label: 'Potion', parm: 'accessories' },
	  { value: 'Teddy Bear', label: 'Teddy Bear', parm: 'accessories' },
	  { value: 'Wine Bottle', label: 'Wine Bottle', parm: 'accessories' },
	  { value: 'Wine Glass', label: 'Wine Glass', parm: 'accessories' },
];